// extracted by mini-css-extract-plugin
export default {"errorLogo":"styles_errorLogo__7D7Op","text":"styles_text__W0zIT","responsiveBack":"styles_responsiveBack__MRfI4"};